'use strict';

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @classdesc Push notification representation within Chat Client
 * @property {String} [action] - Notification action (`click_action` in FCM/GCM terms and `category` in APN terms)
 * @property {Number} [badge] - Number for the badge
 * @property {String} body - Notification text
 * @property {PushNotification#ChatData} data - Additional Chat data
 * @property {String} [sound] - Notification sound
 * @property {String} [title] - Notification title
 * @property {PushNotification#NotificationType} type - Notification type
 */

var PushNotification =
/**
 * Chat push notification type
 * @typedef {('twilio.channel.new_message' | 'twilio.channel.added_to_channel'
 | 'twilio.channel.invited_to_channel'  | 'twilio.channel.removed_from_channel')} PushNotification#NotificationType
 */
/**
 * Additional Chat data for given Push Notification
 * @typedef {Object} PushNotification#ChatData
 * @property {String} [channelSid] - SID of Channel
 * @property {Number} [messageIndex] - Index of Message in Channel
 * @property {String} [messageSid] - SID of Message
 */
/**
 * @param {PushNotification.Descriptor} data - initial data for PushNotification
 */
function PushNotification(data) {
  (0, _classCallCheck3.default)(this, PushNotification);
  this.title = data.title || null;
  this.body = data.body || null;
  this.sound = data.sound || null;
  this.badge = data.badge || null;
  this.action = data.action || null;
  this.type = data.type || null;
  this.data = data.data || {};
};
exports.PushNotification = PushNotification;